<template>
    <div>
      <b-table :items="filterTableRows" :fields="fields" class="details-couriers-table" id="details-couriers-table" responsive borderless :sticky-header="heightStiky" :tbody-tr-class="rowClass">
        <template #head()="data">
          <div :class="[(data.label && data.field.isNotTheLastElement) && 'border-couriers-table', isComparator ? 'head-comparator-couriers-table' : 'head-details-couriers-table']" v-if="data.field.key !== 'prevPage' && data.field.key !== 'nextPage'">
            <div v-if="data.field.textTooltip" v-b-tooltip.hover :title="$t(data.field.textTooltip)"><img :src="`/icon/${data.field.categorie}.svg`" width="24"/></div>

            <div v-if="data.field.logo"><img :src="data.field.logo" width="150"/></div>
            
            <div class="head-rows">{{data.label}}</div>
          </div>
          <div class="justify-content-center d-flex" v-if="data.field.key === 'prevPage' || data.field.key === 'nextPage'">
            <b-button
              @click="calculatePage(data.field.key)"
              variant="default"
              class="p-0"
              :disabled="data.field.disabled"
              v-b-tooltip.hover="data.field.tooltip"
            >
              <feather-icon :icon="data.field.icon" size="2x" class=""/>
            </b-button>
          </div>
        </template>
        <template #cell(title)="data">
          <div v-if="arrayPaddingTop.includes(data.item.title)"></div>
          <div  class="d-flex" :class="[data.item.status === 'title' ? 'titles-categories' : 'cell-rows']">
            <div v-if="data.item.status !== 'title'" class="div-rows-img">
              <span class="cell-rows-img">
                <img :src="require(`@/assets/images/icons/couriers-catalog-icons/${data.item.key}.svg`)" width="20" height="20"/>
              </span>
            </div>
            <span v-if="data.item.status !== 'title'" class="cell-rows-text">{{ data.item.title }}</span>
            <span v-if="data.item.status === 'title' && data.item.icon" @click="toggleGroup(data.item.title)" class="cursor-pointer border-title w-100 d-flex" :class="data.item.title === 'Condiciones de recaudos' ? 'border-title-recaudos' : ''">
              <div  :id="data.item.title.replace(/\s+/g, '-').toLowerCase()">{{ data.item.title }}</div> <div><feather-icon :icon="data.item.icon" size="14" /></div>
            </span>
          </div>
        </template>
        <template #cell()="data">
          <div v-if="arrayPaddingTop.includes(data.item.title)"></div>
          <div v-if="data.item.status !== 'title' && data.field.key !== 'icon'" class="cell-data">
            <div v-if="arrayRowsWitchIcons.includes(data.item.title) && data.unformatted.icon">
              <img :src="require(`@/assets/images/icons/couriers-catalog-icons/${data.unformatted.icon}.svg`)" width="20" height="20"/>
            </div>
            <span v-else class="p-1">{{ data.unformatted }}</span>
          </div>
          <div class="recaudos-container">
            <div v-if="data.item.title === 'Condiciones de recaudos' && data.item.status === 'title' && data.field.icon === 'ChevronsRightIcon'" class="recaudos-button">
              <b-button
                @click="openModal('ModalTariffsRecaudos')"
                variant="outline-primary"
                v-b-tooltip.hover="'Recaudos'"
              >
                Ver tarifas de recaudos
              </b-button>
            </div>
          </div>
          <div v-if="data.item.status === 'title'" @click="toggleGroup(data.item.title)" class="cursor-pointer w-100 border-title padding-border" :class="data.item.title === 'Condiciones de recaudos' ? 'border-title-recaudos' : ''"></div>
        </template>
      </b-table>
      <modal-tariffs-recaudos :info="info" :isComparator="isComparator" v-if="isOpenModalModalTariffsRecaudos" @closeModal="closeModal"></modal-tariffs-recaudos>
    </div>
</template>
<script>
import ModalTariffsRecaudos from './ModalTariffsRecaudos.vue'

export default {
  name: 'TableDetailsCouriersCatalog',
  components: {
    ModalTariffsRecaudos
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    tableRows: {
      type: Array,
      required: true
    },
    calculatePage: {
      type: Function,
      required: true
    },
    isComparator: {
      type: Boolean,
      default: false
    },
    info: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filterTableRows: [],
      allFields: [],
      allFieldsSeletected: [],
      paginatedFields: [],
      currentPage: 1,
      pageSize: 3,
      prevButton: {key: 'prevPage', label: '', icon: 'ChevronsLeftIcon', disabled: true, tooltip: 'Anterior'},
      nextButton: {key: 'nextPage', label: '', icon: 'ChevronsRightIcon', disabled: true, tooltip: ''},
      selectedColumns: [],
      optionsColumns: [],
      arrayRowsWitchIcons: ['Multibulto', 'Máximo de bultos por envío', 'Seguro incluido', 'Seguro adicional', 'Activación seguro adicional', 'Porcentaje seguro adicional', 'Tope seguro adicional', 'Cobro independiente de indemnización aceptada'],
      arrayPaddingTop: ['Horario de entrega', 'Mínimo de recolección', 'Seguro incluido', 'Información para creación de envío'],
      heightStiky: '100px',
      isOpenModalModalTariffsRecaudos: false
    }
  },
  watch: {
    tableRows: {
      handler() {
        this.filterTableRows = this.tableRows.filter(row => !row.hidden)
        this.$nextTick(() => {
          if (this.$route.query?.showRecaudos) this.scrollToRecaudos()
        })
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      const component = document.querySelector('#details-couriers-table')
      const position = component.getBoundingClientRect()
      this.heightStiky = `${window.innerHeight - position.top + 20}px`
    })
  },
  methods: {
    toggleGroup(val) {
      const groupMap = {
        'Condiciones generales': {
          'scheduling': 'Horario de entrega',
          'delivery_attempts': 'Intentos de entrega',
          'max_packages_boolean': 'Multibulto',
          'max_packages': 'Máximo de bultos por envío',
          'summary': 'Información extra'
        },
        'Recolecciones': {
          'min_pickup': 'Mínimo de recolección',
          'cut_schedule': 'Horario de corte',
          'scheduling_type': 'Agendamiento',
          'pickup_schedule': 'Horario de recolección',
          // 'pickup_point': 'Punto de retiro',
          'pickup_summary': 'Observaciones'
        },
        'Políticas de indemnización': {
          'insurance_included': 'Seguro incluido',
          'insurance_value': 'Tope seguro incluido',
          'additional_insurance': 'Seguro adicional',
          'insurance_percentage': 'Porcentaje seguro adicional',
          'additional_insurance_cap': 'Tope seguro adicional',
          'additional_secure_activation': 'Activación seguro adicional',
          'independent_compensation_collection_accepted': 'Cobro independiente de indemnización aceptada',
          'secure_summary': 'Observaciones'
        },
        'Condiciones de recaudos': {
          'delivery_creation_info': 'Información para creación de envío',
          'collection_cycle': 'Ciclo de recaudo / conciliación',
          'deposit_in_account': 'Abono en cuenta',
          'coverage_population': 'Cobertura / Poblaciones',
          'observations': 'Observaciones'
        }
      }
      const group = Object.keys(groupMap[val])
      this.toggleIcon(val)
      this.changeStateGruop(group)
      this.filterTableRows = this.tableRows.filter(row => !row.hidden)
    },
    toggleIcon(val) {
      const index = this.m_getElementIndex(this.tableRows, 'title', val)
      const icon = this.tableRows[index].icon
      this.tableRows[index].icon = icon === 'ChevronUpIcon' ? 'ChevronDownIcon' : 'ChevronUpIcon'
    },
    changeStateGruop(group) {
      this.tableRows.forEach(item => {
        if (group.includes(item.key)) item.hidden = !item.hidden
      })
    },
    rowClass(item, type) {
      if (item.status !== 'title') return 'cell-rows-data'
    },
    openModal(modal) {
      this.isOpenModalModalTariffsRecaudos = true
      this.$nextTick(() => {
        this.$bvModal.show(modal)
      })
    },
    closeModal(modal) {
      this.isOpenModalModalTariffsRecaudos = false
      this.$bvModal.hide(modal)
    },
    scrollToRecaudos() {
      const element = document.querySelector('#condiciones-de-recaudos')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>
<style lang="scss">
  .titles-categories {
    color: #044389;
    font-weight: 600;
    padding-top: 10px;
  }
  .cell-rows {
    color: #fff
  }
  .cell-rows, .cell-data {
    display: grid;
    min-height: 68px;
    width: 260px;
  }
  .cell-data {
    // background: #F3FCFD;
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
    align-items: center !important;
    justify-content: center !important;
    font-weight: 700;
    text-align: center;
  }
  .icon-data {
    font-weight: 700;
  }
  .cell-rows-text {
    align-content: center;
    width: inherit;
    background: #39549F;
    padding-right: 8px !important;
  }
  .div-rows-img {
    background: #39549F;
    border-bottom-left-radius: 50%;
    border-top-left-radius: 50%;
    align-content: center;
    height: inherit;
  }
  .cell-rows-img {
    background: #fff;
    border-radius: 50%;
    padding: 8px;
    margin: 4px 16px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .details-couriers-table td:nth-child(1), .details-couriers-table th:nth-child(1) {
    width: 260px;
    word-wrap: break-word; /* Permite que el texto se divida en palabras */
    word-break: break-word; /* Asegura que el texto largo se ajuste */
    white-space: normal; /* Permite saltos de línea automáticos */

  }
  .details-couriers-table {
    td {
      padding: 0 !important;
    }
    tr {
      border-top: 8px solid #fff;
    }
  }
  .cell-rows-data{
    > :not(:first-child) {
        background: #F3FCFD;
      }
  }
  .details-couriers-table th {
    background-color: #fff !important;
    margin: 10px !important;
    padding: 0.72rem 0 !important;
    font-size: 24px !important;
  }
  .head-rows {
    font-size: 14px !important;
    justify-items: center;
    align-content: center;
    margin-left: 0.4rem;
  }
  .head-details-couriers-table {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    padding: 4px 4px !important;
    > div {
      color: #044389;
    }
  }
  .border-couriers-table {
    border-right: 1px solid #044389;
  }
  .border-title {
    border-bottom: 1px solid #0443891A !important;
    height: 2rem !important;
    top: 0;
    justify-content: space-between;
  }
  .border-title-recaudos {
    height: 3rem !important;
  }
  .details-couriers-table tbody tr:nth-child(2) {
    padding-top: 8px !important;
  }
  .details-couriers-table .table.b-table > * > tr > *:first-child {
    padding-left: 0 !important;
  }
  .details-couriers-table .table.b-table > * > tr > *:last-child {
    padding-right: 0 !important;
  }
  .space-details-couriers {
  padding: 0.5rem !important;
  }
  .padding-border {
  margin-top: 10px;
  }
  .details-couriers-table table {
    table-layout: fixed;
  }
  .details-couriers-table thead tr th:nth-child(2), .details-couriers-table thead tr th:last-child {
  width: 2em !important;
  max-width: 2em !important;
  }
  .dropdown-details-couriers > .custom-checkbox, .dropdown-additional-charges  > .custom-checkbox {
    margin: 1rem 0;
  }
  .pagination-controls {
    display: grid;
    justify-items: center;
    grid-template-columns: 260px 1fr;
    font-weight: 400;
    font-size: 14px;
    color: #6E6B7B;
  }
  .head-comparator-couriers-table {
    width: 100%;
    text-align: center;
    // display: flex;
    justify-content: center;
    padding: 0.72rem 0 !important;
    > div {
      color: #044389;
    }
  }
  .recaudos-container {
    position: relative;
    overflow: visible;
  }

  .recaudos-button {
    position: absolute;
    left: -13rem;
    top: 0;
    white-space: nowrap;
  }
</style>
